import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';

declare let window: any;

@Injectable({
    providedIn: 'root'
})

export class ModelLocatorService {

    /* TUTORIAL */
    public balao_1 = false;
    public balao_2 = false;
    public balao_3 = false;
    public balao_4 = false;
    public balao_5 = false;
    public balao_6 = false;

    public popup_challenge_1 = false;
    public popup_challenge_2 = false;
    public popup_challenge_3 = false;
    public popup_challenge_4 = false;

    public logado: boolean;
    public version: any = '2023.09.18';
    public dadosLogin: any = {};
    public urlretorno = '';
    public configUso: any = {};
    public cloudLoyalty: any = {};
    public resgate: any = {};
    public saldo: any = {};
    public pts_expirar = 0;
    public ultimaAtividade = '';
    public checkin = false;

    public tokenFirebase = '';
    public pushPermission: boolean;

    public checkinLoja = false;
    public travaAtivacaoSemCheckin = false;
    public travaCheckinSemGeolocalizacao = false;
    public travaCheckinSemChecklist = false;
    public travaInatividade = false;
    public travaInatividadeSemCheckin = false;

    public filtroMVs: any = [];
    public filtroRegionais: any = [];
    public filtroUFs: any = [];
    public filtroDDDs: any = [];
    public filtroCoordenadores: any = [];
    public filtroSupervisores: any = [];
    public filtroCNs: any = [];
    public filtroRedesTipos: any = [];
    public filtroRedes: any = [];
    public filtroLojas: any = [];
    public filtroSegmentos: any = [];
    public filtroAgrupamentos: any = [];
    public filtroPlanos: any = [];
    public filtroFDV: any = [];

    public menu = {
        bottom: true,
        interacao: false,
        multipremios: false,
        multisorte: false,
        beneficios: false,
        premiacao: false,
        superacao: false,
        informacao: false,
        planos: false,
        suporte: true,
        perfil: true,
        ativacoes: false,
        qualidade: false,
        extrato: false,
        resgates: false,
        pontuacao: false,
        classificacao: false,
        estrelas: false,
        carteira: false,
        uploads: false,
        pre: false,
        desafios: false,
        faq: true,
        categoria: true,
        embaixador: true,
    };


    public titulo = 'Time MultiPremiado';

    constructor() {

        this.configUso = environment.config.prod;

        if (window.location.href.lastIndexOf('localhost:8100') !== -1) {
            this.configUso = environment.config.local;
        } else if (window.location.href.lastIndexOf('dev.') !== -1) {
            this.configUso = environment.config.dev;
        } else if (window.location.href.lastIndexOf('hom.') !== -1) {
            this.configUso = environment.config.hom;
        }

    }
}
